export default {
	props: {
		expanded: {
			type: Boolean,
			required: true
		},

		labelledBy: {
			type: String,
			required: true
		},

		selectedOption: {
			type: Object,
			required: true
		},

		close: {
			type: Function,
			required: true
		},

		selectFirst: {
			type: Function,
			required: true
		},

		selectLast: {
			type: Function,
			required: true
		},

		selectDown: {
			type: Function,
			required: true
		},

		selectUp: {
			type: Function,
			required: true
		}
	},

	methods: {
		toggleFocus() {
			if (this.expanded) {
				this.$refs.list.focus();
				this.$emit("list-focused");
			} else {
				this.$refs.list.blur();
				this.$emit("list-blurred");
			}
		}
	},

	mounted() {
		this.toggleFocus();
	},

	updated() {
		this.toggleFocus();
	}
};
